export const languagesDefault = [
  { name: 'English', code: 'en' },
  { name: 'German', code: 'de' },
  { name: 'French', code: 'fr' },
  { name: 'Italian', code: 'it' },
  { name: 'Spanish', code: 'es' },
];
